import React, { useState, useEffect } from 'react'
import Navbar from '../../components/navbar/Navbar'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { executeQuery } from '../../helpers/Database'
import { images } from '../../constants'
import Alert from '../../components/alert/Alert'

const Pipeline = () => {
    const [userId, setUserId] = useState(-1);
    const [firebaseUserId, setFirebaseUserId] = useState(-1);
    const [userEmail, setUserEmail] = useState("");
    const [alertState, setAlertState] = useState(false);
    const [alertSeverity, setAlertSeverity] = useState('');
    const [alertMessage, setAlertMessage] = useState('');

    const setAlert = (severity, message) => {
        setAlertState(true);
        setAlertSeverity(severity);
        setAlertMessage(message);
      };
    
      const clearAlert = () => {
        setAlertState(false);
        setAlertSeverity('');
        setAlertMessage('');
      };    

    const navigate = useNavigate();
    const { currentUser } = useAuth();

    const isNull = (variable) => {
        return ((variable === null) || (typeof variable === "undefined"));
    }

    const getUserId = async (fbId, email) => {
        // console.log("getUserId, entry");
        let result = -1;
        let response = "";

        const fetchUser = async (qry, prm) => {
            // console.log(`fetching user, prm: ${prm}`);
            return await executeQuery(qry, prm);
        }

        const InsertUser = async (qry, prm) => {
            console.log(`inserting user, prm: ${prm}`);
            return await executeQuery(qry, prm);
        }

        try {
            let query = 'SELECT * FROM users WHERE firebase_id = ?';
            let params = [fbId];
   
            if (!isNull(fbId)) {
                response = await fetchUser(query, params);
                if (isNull(response[0])) {
    
                    let query = 'INSERT INTO users (firebase_id, email) VALUES (?,?)';
                    let params = [fbId, email];
    
                    // RESPONSE comes back as an ARRAY!
                    response = await InsertUser(query, params);
                    result = response[0].id;
                } else {

                    // RESPONSE comes back as an ARRAY!
                    result = response[0].id;
                }
            }
        }
        catch (error) {
            console.log(error);
            setAlert('error', `Something went wrong - ${error}`);
        }

        // console.log(`getUserId, returning result: ${result}`);
        return result;
    }

    useEffect(() => {
        window.scrollTo(0, 0);

        if ((currentUser) && (userId === -1)) {
            // console.log("useEffect triggered");
            // getUserId(currentUser.uid, currentUser.email)
            //     .then(userId => {
            //         setUserId(userId); // This will be the actual number
            //     })            
            setFirebaseUserId(currentUser.uid);
            setUserEmail(currentUser.email);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="App-container-2">
            <Navbar />
            {alertState && <Alert alertSeverity={alertSeverity}
              alertMessage={alertMessage}
              onClose={() => clearAlert()} />}            
            <div className="flex flex-col items-center justify-center">
                <h1 className="text-black text-center mb-4">Pipeline</h1>
                <div className='w-full flex justify-center'>
                    <img 
                    className="bg-white rounded-lg shadow dark:border m-4 p-8 max-w-full"
                        src={images.coming_soon}
                        alt='coming_soon'
                    />
                </div>
                <div>
                    <h2 className='text-black max-w-5xl text-center mx-4'> 
                        Pipeline functionality is *COMING SOON* but please feel free to use the button below to ADD new applications!
                    </h2>
                </div>
            </div>
            <div className="absolute bottom-0 left-0 w-full flex justify-center mb-4">
                <button
                    className='border rounded-md border-blue-500
                    bg-main-purple hover:bg-primary-300 
                    p-4 my-2 text-center text-white text-base'
                    onClick={() => navigate('/simple-entry')}
                >
                    Add New Application
                </button>
            </div>
        </div>
    )
}

export default Pipeline
